import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { updateLastWatched, UpdateLastWatchedArgs } from './updateLastWatched';

export const onUpdateLastWatched = async (params: UpdateLastWatchedArgs) => {
  const stats = await updateLastWatched(params);

  queryClient.setQueryData(queryKeys.lastWatched, { ...stats });
};
